import axios from 'axios'
import notification from 'ant-design-vue/es/notification'
import { getToken, removeToken } from '@/utils/auth'
import router from '@/router/index'
import store from '@/store'
import { host } from './index'
import { LOGIN_PATH } from '@/config/constants'

// 标记是否已处理401状态
let isTokenExpiredHandled = false;

// 拦截除数组内的接口
const exclusive = [
]

// 生产/预发环境使用 .env 中的 baseURL，开发环境使用 host（可与代理配合）
const isProdOrPre = ['production', 'pre'].includes(process.env.NODE_ENV)
const service = axios.create({
  baseURL: isProdOrPre ? process.env.VUE_APP_API_BASE_URL : host,
  timeout: 2200000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    let { config: { url }} = response
    url = url.split('?')[0]
    if (response.data.code === 401) {
      if (getToken()) {
        store.commit('SET_TOKEN', '')
        store.commit('SET_ROLES', [])
        removeToken()
      }
      if (!isTokenExpiredHandled) {
        notification.warning({
          message: '提示',
          description: '当前登录状态已过期，请重新登录！',
          duration: 1.5
        })
        isTokenExpiredHandled = true
        setTimeout(() => {
          router.push({ path: LOGIN_PATH })
        }, 1000)
      }
      return Promise.reject(new Error('登录已过期'))
    }
    isTokenExpiredHandled = false
    if (response.data instanceof Blob && response.data.type && response.data.type.toLowerCase().indexOf('json') !== -1) {
      const reader = new FileReader()
      reader.readAsText(response.data, 'utf-8')
      notification.error({
        message: '提示',
        description: '服务器内部异常'
      })
      return Promise.reject(new Error('服务器内部异常'))
    } else {
      if (!exclusive.includes(url)) {
        if (response.data.code !== undefined && response.data.code !== 0) {
          notification.error({
            message: '提示',
            description: response.data.msg || '请求失败',
            duration: 1.5
          })
          return Promise.reject(new Error(response.data.msg || '请求失败'))
        }
        if (response.data.head && !response.data.head.ok) {
          notification.error({
            message: '提示',
            description: response.data.head.failMsg || '请求失败',
            duration: 1.5
          })
          return Promise.reject(new Error(response.data.head.failMsg || '请求失败'))
        }
      }
      if (response.data.body) {
        return response.data.body.data
      } else {
        return response.data
      }
    }
  },
  error => {
    const responseData = error.response && error.response.data
    if (responseData instanceof Blob && responseData.type && responseData.type.toLowerCase().indexOf('json') !== -1) {
      const reader = new FileReader()
      reader.readAsText(responseData, 'utf-8')
      reader.onload = function() {
        try {
          const errorMsg = JSON.parse(reader.result).msg || '下载失败'
          notification.error({
            message: '提示',
            description: errorMsg,
            duration: 1.5
          })
        } catch (e) {
          notification.error({ message: '提示', description: '下载失败', duration: 1.5 })
        }
      }
    } else {
      let code = 0
      try {
        code = responseData && responseData.status
      } catch (e) {
        if (error.toString().indexOf('Error: timeout') !== -1) {
          notification.error({
            message: '提示',
            description: '网络请求超时',
            duration: 1.5
          })
          return Promise.reject(error)
        }
      }
      if (code) {
        // if (code === 401) {
        //   // 用户登录界面提示
        //   Cookies.set('point', 401)
        //   return router.replace({ name: 'login' })
        // } else if (code === 403) {
        //   router.push({ path: '/401' })
        // } else {
        //   const errorMsg = error.response.data.message
        //   if (errorMsg !== undefined) {
        //     notification.error({
        //       message: '提示',
        //       description: errorMsg
        //     })
        //   }
        // }
      } else {
        notification.error({
          message: '提示',
          description: '接口请求失败',
          duration: 1.5
        })
      }
    }
    return Promise.reject(error)
  }
)

export default service
